module.exports = __webpack_public_path__ + "static/media/got.0c407a57.png";